jQuery(document).ready(function () {
  var adaComment =  `<!-- Updated! -->`;
  // 
  var adaSkipContent = '<a href="#content" class="custom-ada-skip-to-link">Skip to content</a>';
  jQuery('body').prepend(adaSkipContent).before(adaComment);
  setTimeout(() => {
    jQuery('.custom-ada-skip-to-link').removeAttr('tabindex');    
  }, 3000);
  // 
  jQuery('.container--l.mxa.py2.ac.outer .sans.p.x').attr('autocomplete', 'Email').before(adaComment);
  // 
  jQuery('.mailing-list-message.mxa').attr({
    'role' : 'status',
    'aria-live' : 'polite'
  }).before(adaComment);
  // 
  jQuery('header .caps.logo').wrap('<span class="caps logo"/>').contents().unwrap().before(adaComment);
  // 
  jQuery('.container--l.mxa.py2.ac.outer label').text('email').before(adaComment);
  // 
  jQuery('.footer-links-pages ul').removeAttr('role');
  jQuery('.footer-links-pages li').removeAttr('role');
  jQuery('.footer-page-links').removeAttr('role');
  // 
  
  // jQuery('.homepage-slider div h1').each(function(){
  //   var adaH1Tags = jQuery(this).attr('class');
  //   jQuery(this).wrap('<h2 class="'+adaH1Tags+'"/>').contents().unwrap();
  // })

  // if (jQuery('.homepage-slider.show--m .tns-nav').length > 0) {
  //   var adaCustomBannerDots = jQuery('.homepage-slider.show--m .tns-nav').html();
  //   var adaSetElementDots = adaCustomBannerDots.replaceAll('<button', '<li><button');
  //   adaSetElementDots = adaSetElementDots.replaceAll('</button>', '</button></li>');
  //   jQuery('.homepage-slider.show--m .tns-nav').html('<ul>'+adaSetElementDots+'</ul>');
  // }
  // 
  if (jQuery('.lydia.caps').length > 0) {        
    jQuery('.lydia.caps').each(function() {
      const $this = $(this);
      if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
          $this.remove();
    });
  }

  if (jQuery('.h4.b.elementa').length > 0) {        
    jQuery('.h4.b.elementa').each(function() {
      const $this = $(this);
      if($this.html().replace(/\s|&nbsp;/g, '').length === 0)
          $this.remove();
    });
  }
  var adaCustomFeaTitle = jQuery('.featured-collection .caps.h1__bordered').text();
  var adaCustomFeaSeelink = jQuery('.featured-collection a[data-productid]').text();
  jQuery('.featured-collection a[data-productid]').attr('aria-label', jQuery.trim(adaCustomFeaSeelink) +' about '+jQuery.trim(adaCustomFeaTitle)).before(adaComment);

  jQuery('.locations-slider a').each(function(){
    var adaCustomLocaTitle = jQuery(this).closest('.ac.outer').find('span').text();
    var adaCustomLocaLink = jQuery(this).text();
    jQuery(this).attr('aria-label', jQuery.trim(adaCustomLocaLink) +' about '+ jQuery.trim(adaCustomLocaTitle)).before(adaComment);
  })

  jQuery('.homepage-slider div .lydia.caps').each(function(){
    var adaCustomBannerLink = jQuery(this).closest('.ac.outer').find('a.button[data-productid]').text();
    var adaCustomBannerTitle = jQuery(this).text();
    jQuery(this).closest('.ac.outer').find('a.button[data-productid]').attr('aria-label', jQuery.trim(adaCustomBannerLink) +' about '+ jQuery.trim(adaCustomBannerTitle)).before(adaComment);
  })

  jQuery('.homepage-slider .ac.outer a.button[data-productid][href="/blogs/medium-feed/devocion-is-b-corp-certified"]').attr('aria-label', 'Learn more about how Devocion is B Corp Certified');

  // submenu
  
  jQuery(".nav-desktop__item.hasChildren a.nav-desktop__link").attr("aria-expanded", "false");
  
  jQuery('header').on('keydown', '.nav-desktop__item.hasChildren:not(.hasChildren--active)', function(e){
      if (e.keyCode == 13) {
          jQuery(this).addClass('hasChildren--active');
          jQuery(this).find('a.nav-desktop__link').attr("aria-expanded", "true");
          e.preventDefault();
      }
  })
  
  jQuery('header .nav-desktop__item.hasChildren').on('keyup', function(e){
    if (e.keyCode == 9) {
        jQuery('header .nav-desktop__item.hasChildren').not(this).removeClass('hasChildren--active');
        jQuery('header .nav-desktop__item.hasChildren').not(this).find('a.nav-desktop__link').attr("aria-expanded", "false");
    }
    if (e.keyCode == 27) {
        jQuery('header .nav-desktop__item.hasChildren').removeClass('hasChildren--active');
        jQuery('header .nav-desktop__item.hasChildren').find('a.nav-desktop__link').attr("aria-expanded", "false");
        jQuery(this).find('a.nav-desktop__link').focus();
    }
  })

  jQuery('header .nav-desktop__item a.nav-desktop__link, a.subscription-quiz-button, a.js-site-logo.site-logo').focus(function(){
      jQuery('header .nav-desktop__item.hasChildren').removeClass('hasChildren--active');
      jQuery('header .nav-desktop__item.hasChildren').find('a.nav-desktop__link').attr("aria-expanded", "false");
  })

  // var adaFooterId = jQuery('#shopify-section-footer').attr('id');
  // var adaFooterClass = jQuery('#shopify-section-footer').attr('class');
  // jQuery('#shopify-section-footer').before(adaComment).wrap('<footer id="'+adaFooterId+'" class="'+adaFooterClass+'" role="contentinfo" />').contents().unwrap();
  jQuery('#shopify-section-footer').attr('role','contentinfo');

// 30. Unnecessary textual description provided for image link - start
     jQuery(".block.z1:not(.aa_featuredproductimage)").attr("alt", "");
  // 30. Unnecessary textual description provided for image link - end

  // 32. Empty alt attribute provided for image link - Start
     jQuery(".in-store-gift-block img").attr("alt", "Devocion Home page");
  // 32. Empty alt attribute provided for image link - End


  // 
   jQuery(".aa_size-link.oz.aactive img").attr("alt", "");


  //
  var i = 1;
        jQuery(".list-collection-grid .grid-item.f.ac").each(function () {            
            jQuery(this).find("h2").attr("id", "product-"+ i);
            jQuery(this).find("a.button.btn__yellow.btn__border-black").attr("id", "add-cart"+ i);
            jQuery(this).find("a.button.btn__yellow.btn__border-black").attr('aria-labelledby', 'product-'+ i  + ' ' + 'add-cart'+ i);
            i++;
        })

  //

  jQuery('.featured-collection a:eq(0)').attr("aria-label","See all Coffees");

// new

    jQuery('.social-links a').attr({
      'target': '_blank',
      'rel': 'noopener noreferrer'
    });
    // jQuery('.social-links a svg, .social-links a img').each(function() {
    //     var href = jQuery(this).parent().attr("href"); // Get the href attribute of the parent <a> tag
    //     var domain = href.replace(/^https?:\/\/(www\.)?/, '').replace(/\/.*$/, '').replace(/\.com$/, ''); // Extract domain from href
    //     jQuery(this).attr("alt", domain); // Set the alt attribute of the <svg> or <img> tag to the extracted domain
    // });
    jQuery('.social-links a svg, .social-links a img').each(function() {
        var href = jQuery(this).parent().attr("href"); // Get the href attribute of the parent <a> tag
        var domain = href.replace(/^https?:\/\/(www\.)?/, '').replace(/\/.*$/, '').replace(/\.com$/, ''); // Extract domain from href
        jQuery(this).attr("alt", domain); // Set the alt attribute of the <svg> or <img> tag to the extracted domain
    });   
    
    jQuery('.social-links a svg').before('<span class="sr-only">(Opens in new window)</span>');


    jQuery('a[href="https://www.bcorporation.net/en-us/"] img').attr('alt', 'Certified - B Corporation').before('<span class="sr-only">(Opens in new window)</span>');
    


   jQuery('form div.py1_5 span').each(function() {
      var classes = jQuery(this).attr('class');
      var label = jQuery('<label>');
      label.addClass(classes);
      label.attr({
          'for': 'quantity',
          // 'id': 'quantity',
      });
      label.text('Quantity');
      jQuery(this).replaceWith(label);
  });
  jQuery('.js-counter-quantity.ac').attr('id', 'quantity');
  
    jQuery('.js-counter-remove').attr('aria-label', 'decrease');    
    jQuery('.js-counter-add').attr('aria-label', 'increase');


  var popupDiv = jQuery('div[role="dialog"][aria-label="POPUP Form"]');    
    popupDiv.attr('aria-live', 'polite');

  // 
  setTimeout(() => {
    jQuery('.needsclick.go3275890660.kl-private-reset-css-Xuajs1').attr({
    	'aria-live' : 'polite'
    })
  },15000)


  
  // 
    jQuery('li.nav-desktop__item.rel.hasChildren').mouseover(function () {
		jQuery(this).find('a').first().attr('aria-expanded', 'true');
	})
	
	jQuery('li.nav-desktop__item.rel.hasChildren').mouseout(function () {
		jQuery(this).find('a').first().attr('aria-expanded', 'false');
        jQuery(this).removeClass('hasChildren--active')
	})

    jQuery(document).click(function () {      
		jQuery('li.nav-desktop__item.rel.hasChildren').find('a').first().attr('aria-expanded', 'false');
        jQuery('li.nav-desktop__item.rel.hasChildren').removeClass('hasChildren--active');
    })

    jQuery('header .nav-desktop__item.hasChildren a.nav-desktop__link').focus(function(e){
      jQuery(this).closest('.hasChildren').addClass('hasChildren--active');
      jQuery(this).attr("aria-expanded", "true");
    })

  // 
  // jQuery('[data-component="productForm"] [role="button"][data-productid]').click(function () {
  //   setTimeout(() => {
  //       if (jQuery('body').hasClass('rebuy-modal-visible')) {
  //           setTimeout(() => {
  //               jQuery('button.rebuy-notification-dialog-button').focus();
  //           }, 300)
  //       }
  //   }, 500)
  // })

  jQuery('section.homepage-slider.show--m a.x.y.abs.block').each(function () {
    jQuery(this).attr('tabindex', '-1');
  })


   jQuery(document).on('keydown','#rebuy-modal',function(e){

        var keyCode = e.keyCode || e.which;
        if (keyCode === 9) { // Check if the pressed key is tab
            e.preventDefault(); 
        }// Prevent the default tab behavior
     
    });
    jQuery(document).on('keydown', '.homepage-slider .tns-nav button.tns-nav-active', function(e){
    	var keyCode = e.keyCode || e.which;		
        	if	(keyCode === 9){
        		// jQuery(this).closest('.homepage-slider').find('.hero-slide.rel.tns-item.tns-slide-active .cta-button a').focus();
        		jQuery('.homepage-slider .hero-slide.rel.tns-item.tns-slide-active .cta-button a').focus();
                e.preventDefault(); 
        	}
            if (e.shiftKey){
        		jQuery('.js-cart-drawer-toggle').focus();
        	}
    })
    
    // jQuery('.homepage-slider .hero-slide.rel.tns-item.tns-slide-active .cta-button a').on('keydown', function(e){
    // 	var keyCode = e.keyCode || e.which;		
    // 	if	(keyCode === 9){
    // 		jQuery('.homepage-slider .tns-nav button.tns-nav-active').focus();
    // 	}
    // })


  
})


jQuery(document).ready(function(){
  checkForForm(0);
  function checkForForm(limitter){
    if(limitter > 60*5){
      return;
    } else {
      if(document.querySelector("form.needsclick") && document.querySelector("form.needsclick").querySelector("input")){
        const formButton = document.querySelector("form.needsclick").querySelector("input");
        formButton.focus();
      } else {
        setTimeout((limitter)=>{
          checkForForm(limitter+1);
        }, 1000)
      }
    }
  }
});